module.exports = __webpack_public_path__ + "img/02-drugs.09b85e84.svg";